// Header / mobile-menu navigation model for this vertical (homepage/user_experience.md #5).
// PrimaryNav.js + MobileNavMenu.js are identical across every vertical; this file is the one
// piece that differs. See car_rental/src/navConfig.js for the full contract.
import { PROPERTY_CATEGORIES } from './listingOptions';

export default function buildNav({ isAuthenticated, has }) {
  const links = [];
  if (isAuthenticated && ['customer', 'owner', 'admin', 'delivery', 'cab_vendor', 'reservation_manager', 'corporate_admin', 'corporate_manager'].some(has)) links.push({ type: 'link', label: 'Tracking map', to: '/tracking' });

  if (has('customer')) links.push({ type: 'link', label: 'My Visits', to: '/my-visits' });
  if (has('owner')) links.push({ type: 'link', label: 'My Properties', to: '/owner' });
  if (has('delivery')) links.push({ type: 'link', label: 'My Site Visits', to: '/agent' });
  if (has('admin')) links.push({ type: 'link', label: 'Admin', to: '/admin' });

  return {
    brand: '🏠 Real Estate',
    browseCategories: PROPERTY_CATEGORIES.map((c) => ({ label: c, value: c })),
    links,
    loggedOutLinks: []
  };
}
